import { bookingApi } from "@infrastructure/api";
import { ReservationBookingSchema } from "../models";
// =============================================================================
// IMPLEMENTATION
// =============================================================================
export const reservationRepository = {
    async list(filters, cursor, limit = 25) {
        const response = await bookingApi.list({
            source: filters.source ?? undefined,
            reservationStatus: filters.reservationStatus ?? undefined,
            fulfillmentStatus: filters.fulfillmentStatus ?? undefined,
            serviceId: filters.serviceId ?? undefined,
            cursor: cursor ?? undefined,
            limit,
        });
        const { items, nextCursor } = response.data.data;
        return {
            items: items.map((dto) => ReservationBookingSchema.parse(dto)),
            nextCursor,
        };
    },
    async getById(bookingId) {
        const response = await bookingApi.getById(bookingId);
        return ReservationBookingSchema.parse(response.data.data);
    },
};
export default reservationRepository;
